import { Div, Spacer, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'

import { Icon, SplitContentContainer } from 'src/chrome'
import { useSelector } from 'src/hooks'
import { FlexColumn } from 'src/styled'

import planContentStyles from '../PlanContentsGrid/planContentsGrid.module.scss'

const styles = {
  column: {
    width: '50%',
    alignItems: 'center',
    margin: '15px auto',
  },
  iconWrapper: {
    width: 80,
    marginBottom: 20,
  },
}

const AccountStorage: React.FC = () => {
  const { width } = useSelector(state => state.window)

  const baseIconProps = {
    color: '#9C9CA0',
    size: 80,
  }

  return (
    <Div
      className={`${planContentStyles.featureGridContainer} ${planContentStyles.offWhite}`}
      style={{
        padding: '85px 0 135px 0',
      }}
    >
      <Div className={planContentStyles.featureGrid}>
        <Text type="subtitle" weight="bold">
          Account Storage
        </Text>
        <Spacer space="x7" />
        <SplitContentContainer
          isSplitBorderEnabled={false}
          containerStyle={{ width: '100%' }}
          shouldStackContent={(width || 1000) <= 800}
        >
          <FlexColumn css={styles.column}>
            <Div css={styles.iconWrapper}>
              <Icon {...baseIconProps} icon={'FUNNEL'} size={64} />
            </Div>
            <Text type="largeBody" color="primaryHeading" weight="semiBold">
              Enhanced Storage
            </Text>
            <Spacer space="x2" />
            <Div>
              <Text type="caption">
                Enhanced storage allows you save 500 cards, 1,000 pictures, 100
                campaigns, and 500 contacts.
              </Text>
            </Div>
          </FlexColumn>
          <FlexColumn css={styles.column}>
            <Div css={styles.iconWrapper}>
              <Icon {...baseIconProps} icon={'EQUALIZER'} size={64} />
            </Div>
            <Text type="largeBody" color="primaryHeading" weight="semiBold">
              Premium Storage
            </Text>
            <Spacer space="x2" />
            <Div>
              <Text type="caption">
                Premium storage allows you to save unlimited cards, pictures,
                campaigns, and contacts.
              </Text>
            </Div>
          </FlexColumn>
        </SplitContentContainer>
      </Div>
    </Div>
  )
}

export default AccountStorage
